module.exports = "/img/ford.a28fd25f.png";